export const Resources = {
  ViewOnly: [
    { resourceName: "View All Data", selected: false },
    { resourceName: "View Roles", selected: false },
    { resourceName: "View Audit Trail", selected: false },
  ],
  Modify: [
    { resourceName: "Modify All Data", selected: false },
    { resourceName: "Create Dataset", selected: false },
    { resourceName: "Create Template", selected: false },
    { resourceName: "Create Role", selected: false },
    { resourceName: "Edit Role", selected: false },
    { resourceName: "Delete Role", selected: false },
  ],
};
